import React, { Component } from "react";

class Cart extends Component {
  state = {
    cart: [
      { imageURL: "", name: "Demo Product", price: 1500, qty: 1 },
      { imageURL: "", name: "Another Item", price: 1200, qty: 2 }
    ],
    shipping: 10,
    taxRate: 0.05
  };

  handleChange = (index, field, value) => {
    const cart = [...this.state.cart];
    cart[index][field] = value;
    this.setState({ cart });
  };

  deleteRow = (index) => {
    const cart = [...this.state.cart];
    cart.splice(index, 1);
    this.setState({ cart });
  };

  calculateSubtotal = (price, qty) => {
    if (!price || !qty) return 0;
    return price * qty;
  };

  calculateCartTotal = () => {
    return this.state.cart.reduce(
      (acc, item) => acc + (item.price * item.qty || 0),
      0
    );
  };

  goToGoalKeeper = () => {
    window.location.href = "/goalkeeper";
  };

  goToCheckout = () => {
    window.location.href = "/checkout";
  };

  render() {
    const cartTotal = this.calculateCartTotal();
    const taxAmount = cartTotal * this.state.taxRate;
    const shipping = this.state.shipping;
    const grandTotal = cartTotal + taxAmount + shipping;

    return (
      <>
        <style>{`
          .smooth-hover { transition:.25s ease; }
          .smooth-hover:hover { transform:translateY(-2px); }

          /* Neon buttons – same as Login/SignUp / Checkout */
          .neon-green-btn {
            background: linear-gradient(135deg, #32ff72, #46ff60);
            color: #0b1a23;
            padding: 12px 32px;
            border-radius: 40px;
            border: none;
            cursor: pointer;
            font-weight: 700;
            font-size: 15px;
            box-shadow: 0 4px 18px rgba(60,255,90,0.35);
            transition: 0.25s ease;
            display:inline-flex;
            align-items:center;
            gap:6px;
          }
          .neon-green-btn:hover {
            box-shadow: 0 4px 26px rgba(60,255,90,0.55);
            transform: translateY(-2px);
          }

          .cart-shell {
            max-width:1000px;
            margin:0 auto;
            padding:25px 28px;
            background:rgba(255,255,255,0.06);
            border-radius:22px;
            border:1px solid rgba(255,255,255,0.18);
            backdrop-filter:blur(16px);
            -webkit-backdrop-filter:blur(16px);
            box-shadow:0 10px 40px rgba(0,0,0,0.35);
          }

          .cart-header {
            background:linear-gradient(135deg,#1d3557,#2c4e7a);
            padding:18px;
            border-radius:16px;
            margin-bottom:24px;
            text-align:center;
            color:#fff;
            font-weight:700;
            font-size:24px;
            letter-spacing:.5px;
            box-shadow:0 0 25px rgba(15,23,42,0.7);
          }

          .cart-table-card {
            background:rgba(255,255,255,0.9);
            border-radius:16px;
            border:1px solid #e2e8f0;
            overflow:hidden;
          }

          .cart-table {
            width:100%;
            border-collapse:collapse;
          }

          .cart-th {
            background:#1d3557;
            color:#fff;
            padding:12px 14px;
            font-size:14px;
            font-weight:700;
            text-align:left;
          }

          .cart-td {
            padding:12px 14px;
            border-bottom:1px solid #e5e7eb;
            background:#fff;
            font-size:14px;
          }

          .cart-input {
            width:100%;
            padding:9px 10px;
            border-radius:10px;
            border:1px solid #d1d5db;
            background:#f9fafb;
            font-size:14px;
            outline:none;
            transition:.2s;
          }
          .cart-input:focus{
            border-color:#3b82f6;
            box-shadow:0 0 0 3px rgba(59,130,246,0.25);
            background:#fff;
          }

          .cart-summary-box {
            margin-top:22px;
            padding:18px 16px;
            border-radius:16px;
            background:rgba(11,23,45,0.96);
            border:1px solid rgba(148,163,184,0.6);
            color:#e5e7eb;
            text-align:right;
          }

          .cart-summary-box hr{
            border-color:rgba(148,163,184,0.6);
            margin:8px 0 10px;
          }

          .cart-summary-row{
            font-size:15px;
            font-weight:600;
            line-height:1.8;
          }

          .cart-summary-grand{
            font-size:22px;
            font-weight:800;
            color:#f9fafb;
          }

          @media(max-width:768px){
            .cart-shell{
              padding:18px 14px;
            }
            .cart-header{
              font-size:20px;
              padding:14px;
            }
            .neon-green-btn{
              width:100%;
              justify-content:center;
            }
            .cart-footer-btns{
              flex-direction:column;
              align-items:stretch;
            }
          }
        `}</style>

        <div style={{ padding: "45px 0" }}>
          <div className="cart-shell">
            {/* HEADER */}
            <div className="cart-header">Shopping Cart</div>

            <form>
              {/* CART TABLE */}
              <div className="cart-table-card">
                <table className="cart-table">
                  <thead>
                    <tr>
                      <th className="cart-th">Product</th>
                      <th className="cart-th">Name</th>
                      <th className="cart-th">Price $</th>
                      <th className="cart-th">Qty</th>
                      <th className="cart-th">Subtotal $</th>
                      <th className="cart-th">Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {this.state.cart.map((row, index) => (
                      <tr
                        key={index}
                        style={{
                          background: index % 2 === 0 ? "#f9fafb" : "#ffffff"
                        }}
                      >
                        {/* PRODUCT IMAGE */}
                        <td className="cart-td">
                          {row.imageURL ? (
                            <img
                              src={row.imageURL}
                              alt="product"
                              style={{
                                width: "80px",
                                height: "80px",
                                objectFit: "cover",
                                borderRadius: "12px",
                                border: "2px solid #e5e7eb"
                              }}
                            />
                          ) : (
                            <span
                              style={{ color: "#9ca3af", fontSize: "13px" }}
                            >
                              No Image
                            </span>
                          )}
                        </td>

                        {/* NAME */}
                        <td className="cart-td">
                          <input
                            type="text"
                            value={row.name}
                            onChange={(e) =>
                              this.handleChange(index, "name", e.target.value)
                            }
                            className="cart-input"
                          />
                        </td>

                        {/* PRICE */}
                        <td className="cart-td">
                          <input
                            type="number"
                            value={row.price}
                            onChange={(e) =>
                              this.handleChange(
                                index,
                                "price",
                                Number(e.target.value)
                              )
                            }
                            className="cart-input"
                          />
                        </td>

                        {/* QTY */}
                        <td className="cart-td">
                          <input
                            type="number"
                            min="1"
                            value={row.qty}
                            onChange={(e) =>
                              this.handleChange(
                                index,
                                "qty",
                                Number(e.target.value)
                              )
                            }
                            className="cart-input"
                          />
                        </td>

                        {/* SUBTOTAL */}
                        <td
                          className="cart-td"
                          style={{ fontWeight: 700, color: "#1d3557" }}
                        >
                         $ {this.calculateSubtotal(row.price, row.qty)}
                        </td>

                        {/* DELETE BUTTON */}
                        <td className="cart-td">
                          <button
                            type="button"
                            onClick={() => this.deleteRow(index)}
                            style={{
                              padding: "8px 14px",
                              background: "#e63946",
                              color: "white",
                              border: "none",
                              borderRadius: "10px",
                              cursor: "pointer",
                              fontWeight: "600",
                              boxShadow:
                                "0 3px 10px rgba(230,57,70,0.3)"
                            }}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* CART TOTAL SUMMARY */}
              <div className="cart-summary-box">
                <div className="cart-summary-row">
                  Cart Total: ${cartTotal.toFixed(2)}
                </div>
                <div className="cart-summary-row">
                  Tax (5%): ${taxAmount.toFixed(2)}
                </div>
                <div className="cart-summary-row">
                  Shipping: ${shipping.toFixed(2)}
                </div>
                <hr />
                <div className="cart-summary-grand">
                  Grand Total: ${grandTotal.toFixed(2)}
                </div>
              </div>

              {/* FOOTER BUTTONS */}
              <div
                className="cart-footer-btns"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "26px",
                  gap: "14px",
                  flexWrap: "wrap"
                }}
              >
                
                <button
                  type="button"
                  onClick={this.goToCheckout}
                  className="neon-green-btn smooth-hover"
                >
                  Proceed to Checkout →
                </button>
              </div>
            </form>
          </div>
        </div>
      </>
    );
  }
}

export default Cart;
